import React from 'react';
import {IconButton, Tooltip} from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';

export const CustomNodeInfoPopup = (props) => {
    const {id} = props;
    return (
        <Tooltip title={`ID: ${id}`} arrow placement="top-end" style={{fontSize: "16px"}}>
            <IconButton aria-label="info" style={{padding: '0px 5px'}}>
                <InfoIcon fontSize="small"/>
            </IconButton>
        </Tooltip>
    )
}